import { render, staticRenderFns } from "./ClientDocs.vue?vue&type=template&id=483bb68b&scoped=true"
import script from "./ClientDocs.vue?vue&type=script&lang=js"
export * from "./ClientDocs.vue?vue&type=script&lang=js"
import style0 from "./ClientDocs.vue?vue&type=style&index=0&id=483bb68b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bb68b",
  null
  
)

export default component.exports